import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {BranchLocationLinkContainerModel} from '../../../../../../models/aggregates/branch';
import {Core2Config} from '../../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({
  providedIn: 'root'
})
export class BranchLocationLinkService extends BaseApiPublicLoginTemplateService<BranchLocationLinkContainerModel, BranchLocationLinkContainerModel, BranchLocationLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-location-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-location-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-location-links';
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-location-links/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }

}
